import { createISOStrDateUtil, getObjectUtil, logUtil } from 'packages/src'
import { getUpdatesWithoutDuplicatesReduxReducerUtil } from '../get-updates-without-duplicates'
import updateReduxUtil from '../../../../utils/update'
import setUtil from '../../../../../../utils/set'
import { REDUX_MODEL_KEY } from '../../../../constants'
import afterUpdateReduxHook from '../../../../hooks/after-update'
import { addReferenceToAssociationsReduxReducerUtil } from '../add-reference-to-associations'

/**
 * @param {State} state
 * @param {updateReduxActionProps} payload
 * @returns {*|string}
 */
export function updateObjectReduxReducerUtil (state, payload) {
  const {
    key,
    path,
    value,
    instancePath,
    options = {}
  } = payload

  const instanceOrObject = (
    instancePath ? getObjectUtil(state, instancePath) : getObjectUtil(state, path)
  )

  logUtil('updateObjectReduxReducerUtil').debug('payload=', payload)

  if (!instanceOrObject) {
    // logSystemUtil('updateObjectReduxReducerUtil').warn(`instanceOrObject at path ${path} does not exist payload=`, payload)
    return state
  }

  let { updates } = payload
  if (!updates) {
    updates = {
      [key]: value
    }
  }

  updates = getUpdatesWithoutDuplicatesReduxReducerUtil(instanceOrObject, updates)
  if (!Object.keys(updates).length) {
    // logSystemUtil('').debug(`[noop]`)
    return state
  }

  let newInstanceOrObject = updateReduxUtil(instanceOrObject, updates, options)
  newInstanceOrObject = setUtil(
    newInstanceOrObject,
    REDUX_MODEL_KEY.UPDATED_AT,
    createISOStrDateUtil()
  )

  state = setUtil(state, path, newInstanceOrObject)

  // Trigger the before update hook if there is one
  state = afterUpdateReduxHook(newInstanceOrObject, state, instanceOrObject)
  const instanceOrObjectAfterHook = getObjectUtil(state, path)
  if (instanceOrObjectAfterHook !== newInstanceOrObject) {
    state = setUtil(state, path, instanceOrObjectAfterHook)
  }

  // Set the instanceOrObject in the state
  return addReferenceToAssociationsReduxReducerUtil(
    state,
    instanceOrObjectAfterHook,
    updates
  )
}
